import { Box, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { IconArrowLeft, NamedLink } from '../../components';
import { ListingPageParamTab } from './EditListingPage.utils';
import { EditListingPageState } from './EditListingPage.duck';
import { getUrlHash } from '../../util/urlHelpers';

interface BackToSearchProps {
  onClick?: () => void;
}

const BackToSearch: FC<BackToSearchProps> = (props) => {
  const { onClick } = props;

  const { params } = useSelector<any>((state) => state.EditListingPage) as EditListingPageState;
  const hash = getUrlHash()?.substring(1);

  const handleClick = () => {
    if (onClick) onClick();
  };

  if (!params) {
    return null;
  }

  return (
    <NamedLink
      name="EditListingPage"
      params={{ ...params, tab: ListingPageParamTab.Search }}
      onClick={handleClick}
      {...{ to: { hash } }}
    >
      <Box display="flex" alignItems="center">
        <IconArrowLeft />
        <Typography variant="body2">Back to Search</Typography>
      </Box>
    </NamedLink>
  );
};

export default BackToSearch;
